import { SvgIcon, SxProps } from "@mui/material";
import SvgDeleteIcon from "jsx:../../../Images/Icons/FontAwesome/light/trash-can.svg";

export function DeleteIcon(props: SxProps) {
    return <SvgIcon component={SvgDeleteIcon} inheritViewBox sx={props} />;
}
